/**
 * Segmented control for switching between ladder views.
 * Generalised from HomeLastSessionHero's 2-way toggle to support 2 or 3 segments.
 *
 * Usage (2-way, homepage):
 *   <SessionLadderToggle
 *     tabs={[{ id: 'mixed', label: 'Mixed' }, { id: 'levels', label: "Men's" }]}
 *     value="mixed"
 *     onChange={setLadderView}
 *   />
 *
 * Usage (light surface, e.g. session performance Games tab):
 *   <SessionLadderToggle
 *     variant="light"
 *     ariaLabel="Game list scope"
 *     tabs={[{ id: 'mine', label: 'My games (3)' }, { id: 'all', label: 'All session (12)' }]}
 *     value="mine"
 *     onChange={setGamesScope}
 *   />
 */
import React from 'react';

export function SessionLadderToggle({
  tabs,
  value,
  onChange,
  variant = 'hero',
  ariaLabel = 'Rating ladder',
}) {
  const isLight = variant === 'light';

  return (
    <div
      className={
        isLight
          ? 'inline-flex max-w-full shrink-0 rounded-lg border border-border-medium bg-surface-subtle p-0.5 shadow-sm'
          : 'inline-flex shrink-0 rounded-lg bg-white/[0.08] border border-white/[0.12] p-0.5'
      }
      role="tablist"
      aria-label={ariaLabel}
    >
      {tabs.map(({ id, label }) => {
        const selected = value === id;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(id)}
            className={
              isLight
                ? `whitespace-nowrap rounded-md px-2.5 py-1.5 text-[11px] font-medium transition-colors sm:px-3 sm:text-xs ${
                    selected
                      ? 'bg-primary text-text-inverse shadow-sm'
                      : 'text-text-secondary hover:bg-black/5 hover:text-text-primary dark:hover:bg-white/10'
                  }`
                : `px-2.5 sm:px-3 py-1 rounded-md text-[11px] sm:text-xs font-semibold transition-colors ${
                    selected
                      ? 'bg-white/15 text-white shadow-sm ring-1 ring-white/10'
                      : 'text-white/50 hover:text-white/75'
                  }`
            }
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
